import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

// import addCookieWithConsent from '../../utilities/addCookieWithConsent';
import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {
  tryToGetMemberships  
} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Accept invite to an org
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestLeaveOrganization = packet => {
  return {
    type: 'REQUEST_LEAVE_ORGANIZATION',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveLeaveOrganizationSuccess = data => ({
  type: 'RECEIVE_LEAVE_ORGANIZATION_SUCCESS',
  data
})

export const receiveLeaveOrganizationFail = data => ({
  type: 'RECEIVE_LEAVE_ORGANIZATION_FAIL',
  data
})

export const tryToLeaveOrganization = packet => (dispatch, getState) => {

  dispatch(requestLeaveOrganization(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/organizations/memberships/' + packet.id, {
      method: 'delete',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveLeaveOrganizationSuccess(json));
      dispatch(tryToGetMemberships());
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveLeaveOrganizationFail({errors:e, lastSubmit: packet}));
    })
}
